import { render, staticRenderFns } from "./ChangeProviderView.vue?vue&type=template&id=517809bd&scoped=true&"
import script from "./ChangeProviderView.vue?vue&type=script&lang=js&"
export * from "./ChangeProviderView.vue?vue&type=script&lang=js&"
import style0 from "./ChangeProviderView.vue?vue&type=style&index=0&id=517809bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517809bd",
  null
  
)

export default component.exports